import adminApiClient from './apiClient.js';

export const usuariosApi = {
  list: async (params = {}) => {
    const { data } = await adminApiClient.get('/usuarios/', { params });
    return data;
  },
};

export default usuariosApi;
